<template>
  <div class="vld-parent">
    <!--loading
      :active.sync="loading"
      :can-cancel="canCancel"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    ></loading-->
    <div class="loading on" v-show="loading">
      <!--'on 추가'-->
      <div class="icon"></div>
    </div>
  </div>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapActions, mapState, mapGetters } from '@common/store/modules/common';
import * as actions from '@common/store/modules/common/types';
import * as getters from '@common/store/modules/common/getters';
export default {
  components: {
    //Loading,
  },
  data() {
    return {
      canCancel: false,
      fullPage: true,
    };
  },
  computed: {
    ...mapGetters({
      loading: getters.LOADING,
    }),
  },
  methods: {
    onCancel() {},
  },
};
</script>
